import React, { useEffect, useState } from 'react';
import { useAboutDispatch, useAboutState } from '../../store/hooks';
import { Col, Container, ListGroup, Row } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';

import Navbar from '../Navbar/NavBar';
// import { getFile } from '../../helpers/helpers';
import { SERVER } from '../../config/server.config';
// import ConfirmationModal from '../Shared/Modals/ConfirmationModal';
import Loader from '../Shared/Loader';

const About = () => {

  const {
    documents,
    announcements,
    // weeklyLeaderBoards: leaderboards,
    announcementExt: announcementsFormat
  } = useAboutState();
  const { getAboutData } = useAboutDispatch();

  useEffect(() => {
    getAboutData();
  }, []);

  const [modal /*setModal*/] = useState(null);
  const [/*errorPdf*/, setErrorPdf] = useState(false);
  const [loading, setLoading] = useState(false);

  // const downloadCsvFile = async (fileName, displayName) => {
  //   const done = await getFile(SERVER.ABOUT_LEADERBOARDS(fileName), `${displayName}.csv`);
  //   if (done) {
  //     setModal(<Modal
  //       show={true}
  //       onHide={() => setModal(null)}
  //       centered
  //       className={'modal-short-message'}
  //     >
  //       <Modal.Body>
  //         <div className={'check-icon'} />
  //         Data successfully exported
  //       </Modal.Body>
  //     </Modal>);
  //   } else {
  //     setModal(<ConfirmationModal
  //       show={1} onHide={() => setModal(null)}
  //       modalConfig={{ actionsClassName: 'display-none' }} modalContent={{
  //       headerContent: ' ',
  //       bodyContent: 'Error downloading file',
  //       cancelContent: ' ',
  //       confirmContent: ' '
  //     }} confirmAction={{}}
  //     />);
  //   }
  //   setTimeout(() => setModal(null), 5000);
  // }

  const downloadPDF = async (fileName: string, displayName: string) => {//`?teamId=${teamId}&compareRange=20190509-20190816`

    const urlFetch = SERVER.ABOUT_USERGUIDE(fileName);
    fetch(urlFetch,
      {
        method: 'GET'
      })
      .then(response => {
        if (response.status !== 200) {
          throw Error(response.statusText);
        }
        return response.text();
      })
      .then(data => {
        const byteString = window.atob(data);
        // Convert that text into a byte array.
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ia], {
          type: 'application/octet-stream;'
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = url;
        a.target = '_blank';
        const fileName = `${displayName}`;
        a.download = `${fileName}.pdf`;
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 1000);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setErrorPdf(true);
        setTimeout(() => setErrorPdf(false), 2500);
      });
  };

  let announcementsParsed: JSX.Element | JSX.Element[] = <></>;
  if (announcements && announcementsFormat === 'txt') {
    announcementsParsed = announcements.split('\n').map((item, i) => {
      return <p key={i}>{item}</p>;
    });
  } else if (announcements && announcementsFormat === 'md') {
    announcementsParsed = <ReactMarkdown>{announcements}</ReactMarkdown>;
  }
  // const leaderboardsItems = leaderboards.map( item => {
  //   return(
  //     <ListGroup.Item onClick={()=>downloadCsvFile(item.fileName, item.displayName)}>
  //       {item.displayName}
  //     </ListGroup.Item>
  //   )
  // })
  const documentsColOne: JSX.Element[] = [];
  const documentsColTwo: JSX.Element[] = [];
  const documentsColThree: JSX.Element[] = [];
  documents.map((document, index) => {
    if(index <= 4){
      documentsColOne.push (
        <ListGroup.Item onClick={() => {
          setLoading(true);
          downloadPDF(document.fileName, document.displayName);
        }} key={'li-'+index}>
          {document.displayName}
        </ListGroup.Item>
      );
    }else if (index > 4 && index <= 9){
      documentsColTwo.push (
        <ListGroup.Item onClick={() => {
          setLoading(true);
          downloadPDF(document.fileName, document.displayName);
        }} key={'li-'+index}>
          {document.displayName}
        </ListGroup.Item>
      );
    }else{
      documentsColThree.push (
        <ListGroup.Item onClick={() => {
          setLoading(true);
          downloadPDF(document.fileName, document.displayName);
        }} key={'li-'+index}>
          {document.displayName}
        </ListGroup.Item>
      );
    }
    
  });
  const documentsItems = documents.map((document, index) => {
    return (
      <ListGroup.Item onClick={() => {
        setLoading(true);
        downloadPDF(document.fileName, document.displayName);
      }} key={'li-'+index}>
        {document.displayName}
      </ListGroup.Item>
    );
  });
  return <>
    {modal}
    <Navbar />
    <Container className="container-00">
      <h4 className="h-t">About</h4>
      
        <>
          <div className="head-filters-01">
            <h5 className="title-ab">Announcements</h5>
          </div>
          <div className="about">
          <Loader style={{ height: 'calc(100vh - 202px)' }} forceLoader={loading}>
            <div className="about-02">
              <p>{announcementsParsed}</p>
            </div>
            <h5 style={{marginLeft: '15px'}}>Important Documents Links</h5>
            <Row>
              <Col lg={4}>
                <ListGroup variant="flush">
                  {documentsColOne}
                  {/* <ListGroup.Item>Swagger Zebra API Specs</ListGroup.Item> */}
                </ListGroup>
              </Col>
              { documentsColTwo.length !== 0 &&(
                <Col lg={4}>
               <ListGroup variant="flush">
                 {documentsColTwo}
               </ListGroup>
             </Col>
              )
              }
              { documentsColThree.length !== 0 &&(
                <Col lg={4}>
               <ListGroup variant="flush">
                 {documentsColThree}
               </ListGroup>
             </Col>
              )
              }
              
            </Row>
            <div className="footer-about">For any questions or feedback please contact <a
              href="mailto:clientservicesupport@zebra.com">clientservicesupport@zebra.com</a></div>
              </Loader>
          </div>
        </>
    </Container>
  </>;
};

export default About;
